import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=c9c48f28&"
import script from "./checklist.vue?vue&type=script&lang=js&"
export * from "./checklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports